import { duplicateCategoryMutation } from '../../../lib/graphql';
import { setLoaderComplete, setLoaderStart } from '../../loader/loader';
import showToaster from '../../../helpers/toastrMessgaes/showToaster';

// Category Studio (A2): clone a category (backend creates it inactive with its
// subcategories + pricing). Caller refetches the tree on success.
const duplicateCategory = (id) => {
    return async (dispatch, getState, { client }) => {
        try {
            dispatch(setLoaderStart('DuplicateCategory'));

            const { data } = await client.mutate({
                mutation: duplicateCategoryMutation,
                variables: { id },
            });

            dispatch(setLoaderComplete('DuplicateCategory'));

            if (data?.duplicateCategory?.status === 200) {
                showToaster({ messageId: 'addCatSuccess', requestContent: data?.duplicateCategory?.result?.name, toasterType: 'success' });
                return { status: 200, result: data?.duplicateCategory?.result };
            }
            showToaster({ messageId: 'errorMessage', requestContent: data?.duplicateCategory?.errorMessage, toasterType: 'error' });
            return { status: 400 };
        } catch (err) {
            dispatch(setLoaderComplete('DuplicateCategory'));
            showToaster({ messageId: 'catchMessage', requestContent: err, toasterType: 'error' });
            return { status: 400 };
        }
    };
};

export default duplicateCategory;
